export let prioritiesDict: { [key: string]: string } = {
    "Normal": "Normal",
    "Urgent": "Urgent",
    "Low-Priority": "Low-Priority"
};

export let priorities: string[] = Object.keys(prioritiesDict).map(k => prioritiesDict[k]);